<template>
  <div class="header-search">
    <a-auto-complete
      placeholder="搜索公司、文档"
      class="search-input"
      :style="isFocus ? 'width: 550px' : ''"
      :value="keyword"
      optionLabelProp="name"
      dropdownClassName="search-global"
      :defaultActiveFirstOption="defaultActiveFirstOption"
      @change="changeHandler"
      @blur="blurHandler"
      @focus="focusHandler"
      ref="globalSearch"
      :getPopupContainer="triggerNode => triggerNode.parentNode"
    >
      <template slot="dataSource" v-if="!loading">
        <a-select-option
          v-for="item in recommended"
          :key="item.idStr + '$$' + item.name"
          @click="select(item)"
          @keydown.stop="select(item)"
          :name="item.name"
          :defaultActiveFirstOption="false"
          :value="item.name"
          data-ga-id="菜单栏-搜索-点击项目列表"
        >
          <div class="search-item">
            <div v-if="item.logoPath" class="logo">
              <img class="search-logo" :src="item.logoPath" />
            </div>
            <div class="content">
              <div class="name" v-html="item.nameHTML"></div>
              <div class="descript" v-html="item.description"></div>
            </div>
          </div>
        </a-select-option>
        <a-select-option
          :value="item.type"
          v-for="item in moreOptions"
          :key="'more-item-' + item.type"
          data-ga-id="菜单栏-搜索-点击搜索更多"
          :data-ga-value="item.type"
        >
          <div class="search-more-item" @click.stop="clickMoreItem(item)">
            <a-icon type="search" />
            <div class="content" v-html="item.htmlText"></div>
            <a-icon type="right" />
          </div>
        </a-select-option>
      </template>
    </a-auto-complete>
  </div>
</template>

<style lang="less" scoped>
/deep/.ant-select-dropdown-menu {
  max-height: 400px !important;
}
.header-search {
  position: relative;
  .search-input {
    width: 250px;
    transition: width 250ms;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(-50%);
    input {
      width: 250px;
      margin-left: 0;
    }
  }
}
.search-global {
  .search-item {
    // background: red;
    margin: 5px 0;
    display: flex;
    align-items: center;
    max-height: 40px;
    .logo {
      width: 35px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      .search-logo {
        display: block;
        max-width: 35px;
        max-height: 35px;
      }
    }
    .content {
      padding-top: 0px;
      margin-left: 10px;
      max-width: 160px;
      overflow: hidden;
      font-size: 14px;
    }
  }
  .search-more-item {
    display: flex;
    align-items: center;
    margin: -5px -10px;
    padding: 5px 10px;
    .content {
      margin: 0 10px;
      /deep/span {
        font-weight: bolder;
      }
    }
  }
}
</style>

<script>
import { search } from '@/api/common.js';
import debounce from 'lodash/debounce';
import { getCompanyList, recentView, ifCanAccess } from '@/api/project';
import { companyList } from '@/api/meeting';
export default {
  data() {
    return {
      loading: false,
      keyword: '',
      recommended: [],
      isFocus: false,
      defaultActiveFirstOption: false,
      oneSelected: false,
      dataSource: [
        {
          title: '全局搜索'
        }
      ],
      moreOptions: [
        {
          htmlText: '搜索更多 <span>公司/项目</span>',
          type: '1'
        },
        {
          htmlText: '搜索相关 <span>工作进展/log</span>',
          type: '2'
        },
        {
          htmlText: '搜索相关 <span>项目文档</span> （全文穿透）',
          type: '3'
        },
        {
          htmlText: '搜索 <span>所有相关文档</span> (ALL)',
          type: '-1'
        }
      ]
    };
  },
  mounted() {
    this.$refs.globalSearch.$el.onkeydown = e => {
      if (e.key === 'Enter' && e.keyCode !== 229) {
        //229为中文输入法选英文时的回车
        this.$ga.gaUploadCustomEvent('菜单栏-搜索关键词');
        window.open(window.location.origin + `/search?key=${this.keyword}`);
      }
    };
  },
  methods: {
    blurHandler() {
      this.isFocus = false;
      this.recommended = [];
    },
    clickMoreItem(item) {
      console.log(item, this.keyword);
      window.open(window.location.origin + `/search?key=${this.keyword}&type=${item.type}`);
    },
    select(item) {
      ifCanAccess({ id: item.id }).then(res => {
        if (res.code === 200 && res.data) {
          window.open(window.location.origin + `/project/detail?id=${item.idStr}`);
        } else if (res.code === 200) {
          // this.$message.error('无访问权限');
          window.open(window.location.origin + `/project/detail?id=${item.idStr}&noPermission=true`);
        }
      });
    },
    debounceSearch: debounce(function(keyword) {
      if (keyword && keyword.length > 0) {
        search({
          searchWord: keyword,
          pageSize: 5,
          type: 1
        })
          .then(res => {
            if (res.code === 200 && res.data.list) {
              this.recommended = [];
              res.data.list.forEach((item, index) => {
                console.log('itemsss', item);
                // this.recommended.push(item);
                let dom = document.createElement('div');
                dom.innerHTML = item.projectName;
                let text = dom.innerText;
                this.recommended.push({
                  name: text,
                  nameHTML: item.projectName,
                  id: item.projectId,
                  logoPath: item.logoPath,
                  description: item.description,
                  idStr: item.projectId.toString()
                });
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        recentView()
          .then(res => {
            if (res.code === 200) {
              this.recommended = [];
              res.data.forEach((item, index) => {
                item.idStr = item.id.toString();
                this.recommended.push({
                  ...item,
                  nameHTML: item.name
                });
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }, 600),
    search(keyword) {
      this.loading = true;
      this.debounceSearch(keyword);
    },
    changeHandler(keyword) {
      this.keyword = keyword;
      this.search(keyword);
    },
    focusHandler() {
      if (this.isFocus === false) {
        this.isFocus = true;
        this.loading = true;
        this.search(this.keyword);
      }
    }
  }
};
</script>
